export enum TributeVideoExportStatus {
  Preparing = 'Preparing',
  Pending = 'Pending',
  InProgress = 'InProgress',
  RenderingCompleted = 'RenderingCompleted',
  Completed = 'Completed',
  Failed = 'Failed',
  Canceled = 'Canceled',
  PreviewCreated = 'PreviewCreated'
}

export enum TributeVideoFailedErrors {
  Unknown = 'Unknown',
  MaxPreparingTime = 'MaxPreparingTime',
  PreparingFailure = 'PreparingFailure',
  RenderingFailure = 'RenderingFailure',
  StorageLimitFailure = 'StorageLimitFailure'
}

export enum ThemeOptionTabs {
  VIDEO_THEME = 'theme',
  CUSTOM_VIDEO_THEME = 'customTheme'
}

export enum TributeVideoBackgroundType {
  Motion = 0,
  Still = 1,
  ContentBased = 2,
  Black = 3
}
